import L from 'leaflet'
import * as PIXI from 'pixi.js'
import 'leaflet-rotatedmarker'
import 'leaflet-pixi-overlay'
import libs from '../../libs'

const state = {
  mapLayer: null,
  groupLayer: null,
  tileLayer: null,
  gridLayer: null,
  pixiOverlay: null,
  wppLayer: null,
  captureLayer: null,
  mapControl: {
    view: [-1.9332268264771106, 113.2470703125],
    zoom: 5,
    grid: true,
    inload: false,
    completeload: false,
    lastOffset: 0,
    lastLimit: 999999,
    mode: 'main'
  },
  activeBasemap: {
    id: null,
    title: null,
    url: null,
    attribution: null,
    max_zoom: null
  },
  activeLayers: {},
  capture: {
    a: null,
    b: null,
    inload: false
  },
  zoneLayer: {}
}

const getters = {
  mapControl: (state) => state.mapControl,
  mapPlay: (state) => state.mapPlay,
  activeBasemap: (state) => state.activeBasemap,
  capture: (state) => state.capture
}

const actions = {
  toInitMap: async ({ rootState, state, commit, dispatch }, domMapContainer) => {
    await dispatch('toLoadActiveFilter')
    await dispatch('toLoadActiveBasemap')

    const mapLayer = L.map(domMapContainer, {
      preferCanvas: true,
      zoomControl: false,
      // zoomAnimation: false,
      // fadeAnimation: false,
      // markerZoomAnimation: false
    }).setView(state.mapControl.view, state.mapControl.zoom)

    const groupLayer = L.layerGroup()
    const tileLayer = L.tileLayer(state.activeBasemap.url, {
      id: state.activeBasemap.id,
      attribution: state.activeBasemap.attribution,
      maxZoom: state.activeBasemap.max_zoom,
      tileSize: 256,
      // zoomOffset: -1
    })
    const scaleControl = L.control.scale()

    mapLayer.addLayer(groupLayer)
    mapLayer.addLayer(tileLayer)
    scaleControl.addTo(mapLayer)

    let gridLayer = null

    if (state.mapControl.grid) {
      gridLayer = new L.GridLayer()

      gridLayer.createTile = function () {
        const tile = L.DomUtil.create('canvas', 'leaflet-tile')
        const ctx = tile.getContext('2d')
        const size = this.getTileSize()

        tile.width = size.x
        tile.height = size.y

        ctx.strokeStyle = '#666666'
        ctx.lineWidth = 0.1

        ctx.beginPath()
        ctx.moveTo(0, 0)
        ctx.lineTo(size.x - 1, 0)
        ctx.lineTo(size.x - 1, size.y - 1)
        ctx.lineTo(0, size.y - 1)
        ctx.closePath()
        ctx.stroke()

        return tile
      }

      mapLayer.addLayer(gridLayer)
    }

    const pixiContainer = new PIXI.Container()
    const kapalIcon1 = PIXI.Texture.from(require('../../assets/marker/direction1.png'))
    const kapalIcon2 = PIXI.Texture.from(require('../../assets/marker/direction2.png'))
    const kapalIcon3 = PIXI.Texture.from(require('../../assets/marker/direction3.png'))
    const kapalIcon4 = PIXI.Texture.from(require('../../assets/marker/direction4.png'))
    const kapalIcon5 = PIXI.Texture.from(require('../../assets/marker/direction5.png'))
    const locationIcon = PIXI.Texture.from(require('../../assets/marker/location.png'))

    PIXI.BitmapFont.from('KapalGrouping', {
      fill: '#000000',
      fontSize: 48
    })

    PIXI.BitmapFont.from('KapalTooltip', {
      fill: '#FFFFFF',
      fontSize: 11
    }, {
      chars: PIXI.BitmapFont.ASCII
    })

    PIXI.BitmapFont.from('PortTooltip', {
      fill: '#000000',
      fontSize: 11
    }, {
      chars: PIXI.BitmapFont.ASCII
    })

    let inload = false
    let redraw = false
    let inicon = false
    let wppContainer = null
    let portContainer = null
    let kapalContainer = null
    let trackingContainer = null
    let toolsContainer = null

    const cursors = {
      timestamp: null,
      list: {}
    }
    const toolDistances = {
      timestamp: null,
      type: 'x',
      x: null,
      list: {},
      unlist: {}
    }

    const toggleInicon = function () {
      inicon = !inicon
    }

    const toggleCursor = function (cursorIndex, coordinates, singleCursor) {
      if (cursors.list[cursorIndex]) {
        delete cursors.list[cursorIndex]
      } else {
        cursors.list[cursorIndex] = {
          timestamp: null,
          coordinates: coordinates
        }
      }

      if (singleCursor) {
        for (var cursorIndexed in cursors.list) {
          if (cursorIndexed !== cursorIndex) {
            delete cursors.list[cursorIndex]
          }
        }
      }
    }

    const editCursor = function (cursorIndex, properties) {
      cursors.list[cursorIndex].timestamp = properties.timestamp
      cursors.list[cursorIndex].width = properties.width
      cursors.list[cursorIndex].height = properties.height
      cursors.list[cursorIndex].position = properties.position
      cursors.list[cursorIndex].ping_time = properties.ping_time
      cursors.list[cursorIndex].speed = properties.speed
    }

    const addToolDistance = function (distanceIndex, coordinates, isUnlist = false) {
      if (toolDistances.type === 'y') {
        if (distanceIndex === toolDistances.x) {
          return
        }

        toolDistances.list[distanceIndex] = {
          timestamp: null,
          type: 'y',
          x: toolDistances.x,
          coordinates: coordinates,
          unlist: isUnlist
        }
        toolDistances.list[toolDistances.x].y = distanceIndex
        toolDistances.type = 'x'
        toolDistances.x = null
      } else {
        toolDistances.type = 'y'
        toolDistances.x = distanceIndex
        toolDistances.list[distanceIndex] = {
          timestamp: null,
          type: 'x',
          coordinates: coordinates,
          unlist: isUnlist
        }
      }

      if (isUnlist) {
        toolDistances.unlist[distanceIndex] = true
      }
    }

    const editToolDistance = function (distanceIndex, properties) {
      toolDistances.list[distanceIndex].timestamp = properties.timestamp
      toolDistances.list[distanceIndex].width = properties.width
      toolDistances.list[distanceIndex].height = properties.height
      toolDistances.list[distanceIndex].position = properties.position
    }

    const removeToolDistance = function (distanceIndex) {
      if (toolDistances.list[distanceIndex].type === 'x') {
        const y = toolDistances.list[distanceIndex].y

        if (y) {
          if (toolDistances.list[y].unlist) {
            delete toolDistances.unlist[y]
          }

          delete toolDistances.list[toolDistances.list[distanceIndex].y]
        }

        if (toolDistances.list[distanceIndex].unlist) {
          delete toolDistances.unlist[distanceIndex]
        }

        delete toolDistances.list[distanceIndex]
      } else {
        const x = toolDistances.list[distanceIndex].x

        if (x) {
          if (toolDistances.list[x].unlist) {
            delete toolDistances.unlist[x]
          }

          delete toolDistances.list[toolDistances.list[distanceIndex].x]
        }

        if (toolDistances.list[distanceIndex].unlist) {
          delete toolDistances.unlist[distanceIndex]
        }

        delete toolDistances.list[distanceIndex]
      }

      toolDistances.type = 'x'
    }

    const pixiOverlay = L.pixiOverlay(async (utils) => {
      if (inload) {
        redraw = true

        return
      } else {
        inload = true
      }

      const container = utils.getContainer()
      const renderer = utils.getRenderer()
      const scale = utils.getScale()
      const zoom = mapLayer.getZoom()
      const bound = mapLayer.getBounds()

      if (kapalContainer) {
        container.removeChild(kapalContainer)
      }

      if (toolsContainer) {
        container.removeChild(toolsContainer)
      }

      if (wppContainer) {
        container.removeChild(wppContainer)
      }

      if (portContainer) {
        container.removeChild(portContainer)
      }

      wppContainer = new PIXI.Container()
      portContainer = new PIXI.Container()
      kapalContainer = new PIXI.Container()
      toolsContainer = new PIXI.Container()

      container.sortableChildren = true
      kapalContainer.sortableChildren = true
      wppContainer.zIndex = 8
      portContainer.zIndex = 8
      kapalContainer.zIndex = 10
      toolsContainer.zIndex = 10

      cursors.timestamp = Date.now()
      toolDistances.timestamp = cursors.timestamp

      if (state.mapControl.mode === 'history') {
        if (trackingContainer) {
          trackingContainer.clear()
        } else {
          trackingContainer = new PIXI.Graphics()

          trackingContainer.zIndex = 9

          container.addChild(trackingContainer)
        }

        for (var historyIndex in rootState.history.histories) {
          const history = rootState.history.histories[historyIndex]

          if (typeof history.cluster === 'undefined') continue

          let cluster = null

          if (rootState.history.history.mode === 'play') {
            cluster = history.features
          } else {
            cluster = history.cluster.getClusters([
              bound._southWest.lng,
              bound._southWest.lat,
              bound._northEast.lng,
              bound._northEast.lat
            ], zoom)

            // always show cursor indexed so add it to cluster
            for (let groupIndex in cluster) {
              const groupNum = parseInt(groupIndex) + 1

              if (cluster[groupIndex].properties.index === rootState.history.history.index) {
                break
              } else if (groupNum >= cluster.length) {
                cluster.push(rootState.history.history.features[rootState.history.history.indexed.index])
              }
            }
          }

          for (let groupIndex in cluster) {
            const group = cluster[groupIndex]
            const groupIndexed = group.properties.index

            if (rootState.history.history.mode === 'play' &&
              groupIndexed >= rootState.history.history.index) {
              break;
            }

            const position = utils.latLngToLayerPoint([
              group.geometry.coordinates[1],
              group.geometry.coordinates[0]
            ])

            const kapalIcon = new PIXI.Sprite(kapalIcon3)

            kapalIcon.zIndex = 3
            kapalIcon.x = position.x
            kapalIcon.y = position.y

            kapalIcon.anchor.set(0.5, 0.5)
            kapalIcon.scale.set(0.25 / scale)

            const kapalIconWidth = (kapalIcon.width / 4)
            const kapalIconHeight = (kapalIcon.height / 4)

            kapalIcon.angle = group.properties.HEADING
            kapalIcon.interactive = true
            kapalIcon.interactiveChildren = true
            kapalIcon.buttonMode = true

            kapalIcon.on('pointerdown', () => {
              if (rootState.tools.tools.map.distance) {
                if (toolDistances.list[groupIndexed]) {
                  removeToolDistance(groupIndexed)
                } else {
                  addToolDistance(groupIndexed, [group.geometry.coordinates[1], group.geometry.coordinates[0]])
                }
              } else {
                if (rootState.history.history.transmitter !== history.transmitter) {
                  commit('setKapal', history.kapal)
                  commit('setHistory', {
                    transmitter: history.transmitter,
                    start: history.start,
                    end: history.end,
                    features: history.features
                  })
                }

                commit('setHistoryIndex', {
                  index: groupIndexed,
                  indexed: group.properties
                })
                toggleCursor(groupIndexed, group.geometry.coordinates, true)
              }

              pixiOverlay.redraw()
            })

            kapalContainer.addChild(kapalIcon)

            if (cursors.list[groupIndexed]) {
              editCursor(groupIndexed, {
                timestamp: cursors.timestamp,
                width: kapalIconWidth,
                height: kapalIconHeight,
                position: position,
                ping_time: group.properties.PING_TIME,
                speed: group.properties.SPEED
              })
            }

            if (toolDistances.list[groupIndexed]) {
              editToolDistance(groupIndexed, {
                timestamp: toolDistances.timestamp,
                width: kapalIconWidth,
                height: kapalIconHeight,
                position: position
              })
            }

            if (rootState.history.history.index === groupIndexed) {
              if (typeof cursors.list['history-index'] === 'undefined') {
                toggleCursor('history-index', group.coordinates)
              }

              editCursor('history-index', {
                timestamp: cursors.timestamp,
                width: kapalIconWidth,
                height: kapalIconHeight,
                position: position,
                ping_time: group.properties.PING_TIME,
                speed: group.properties.SPEED
              })
            }
          }

          const firstItem = history.features[0]

          if (firstItem) {
            const firstItemPosition = utils.latLngToLayerPoint([
              firstItem.geometry.coordinates[1],
              firstItem.geometry.coordinates[0]
            ])

            trackingContainer.moveTo(firstItemPosition.x, firstItemPosition.y)
          }

          for (var itemIndex in history.features) {
            const item = history.features[itemIndex]
            const itemPosition = utils.latLngToLayerPoint([
              item.geometry.coordinates[1],
              item.geometry.coordinates[0]
            ])

            if (rootState.history.history.mode === 'play' &&
              item.properties.index >= rootState.history.history.index) {
              break;
            }

            trackingContainer.lineTo(itemPosition.x, itemPosition.y)

            const speed = item.properties.SPEED / 10
            let speedColor = 0xFF1000

            if (speed >= 5) {
              speedColor = 0x00CA08
            } else if (speed >= 3) {
              speedColor = 0xEBFF00
            } else if (speed >= 1.5) {
              speedColor = 0xFF9900
            }

            trackingContainer.lineStyle(1 / scale, speedColor, 1, 0.5, true)
          }
        }
      } else if (state.mapControl.mode === 'plotting') {
        if (trackingContainer) {
          trackingContainer.clear()
        } else {
          trackingContainer = new PIXI.Graphics()

          trackingContainer.zIndex = 8

          container.addChild(trackingContainer)
        }

        for (let plotIndex in rootState.plotting.plotting.features) {
          const plot = rootState.plotting.plotting.features[plotIndex]
          const position = utils.latLngToLayerPoint([
            plot.latitude,
            plot.longitude
          ])

          const kapalIcon = new PIXI.Sprite(kapalIcon3)

          kapalIcon.zIndex = 3
          kapalIcon.x = position.x
          kapalIcon.y = position.y
          kapalIcon.angle = plot.heading

          kapalIcon.anchor.set(0.5, 0.5)
          kapalIcon.scale.set(0.25 / scale)

          const kapalIconWidth = (kapalIcon.width / 4)
          const kapalIconHeight = (kapalIcon.height / 4)

          kapalIcon.interactive = true
          kapalIcon.interactiveChildren = true
          kapalIcon.buttonMode = true

          kapalIcon.on('pointerdown', () => {
            if (rootState.tools.tools.map.distance) {
              if (toolDistances.list[plotIndex]) {
                removeToolDistance(plotIndex)
              } else {
                addToolDistance(plotIndex, plot.geometry.coordinates)
              }
            } else {
              commit('setPlottingTo', plotIndex)
              toggleCursor(plotIndex, [plot.latitude, plot.longitude])
            }

            pixiOverlay.redraw()
          })

          kapalContainer.addChild(kapalIcon)

          if (cursors.list[plotIndex]) {
            editCursor(plotIndex, {
              timestamp: cursors.timestamp,
              width: kapalIconWidth,
              height: kapalIconHeight,
              position: position,
              ping_time: plot.ping_time,
              speed: plot.speed
            })
          }

          trackingContainer.lineTo(position.x, position.y)
          trackingContainer.moveTo(position.x, position.y)

          const speed = plot.speed / 10
          let speedColor = 0xFF1000

          if (speed >= 5) {
            speedColor = 0x00CA08
          } else if (speed >= 3) {
            speedColor = 0xEBFF00
          } else if (speed >= 1.5) {
            speedColor = 0xFF9900
          }

          trackingContainer.lineStyle(1 / scale, speedColor, 1, 0.5, true)
        }
      } else if (rootState.poi.poi.kapal.enable === 'AKTIF' &&
        rootState.kapal.listKapal.cluster) {
        const cluster = rootState.kapal.listKapal.cluster.getClusters([
          bound._southWest.lng,
          bound._southWest.lat,
          bound._northEast.lng,
          bound._northEast.lat
        ], zoom)

        for (let groupIndex in cluster) {
          const group = cluster[groupIndex]
          const position = utils.latLngToLayerPoint([
            group.geometry.coordinates[1],
            group.geometry.coordinates[0]
          ])

          if (group.properties.point_count > 1) {
            const groupIcon =  new PIXI.Graphics()
            const groupText = new PIXI.BitmapText('0', {
              fontName: 'KapalGrouping'
            })

            groupIcon.zIndex = 1
            groupIcon.x = position.x
            groupIcon.y = position.y
            groupText.zIndex = 2
            groupText.x = position.x
            groupText.y = position.y

            if (group.properties.point_count <= 50) {
              groupIcon.beginFill(0x4572c1, 0.5)
            } else if (group.properties.point_count <= 100) {
              groupIcon.beginFill(0xa2e73f, 0.5)
            } else if (group.properties.point_count <= 200) {
              groupIcon.beginFill(0xfffe02, 0.5)
            } else if (group.properties.point_count <= 500) {
              groupIcon.beginFill(0xffc002, 0.5)
            } else {
              groupIcon.beginFill(0xbd0100, 0.5)
            }

            groupIcon.drawCircle(0, 0, 72)
            groupIcon.endFill()
            groupIcon.scale.set(0.25 / scale)
            groupText.scale.set(0.25 / scale)
            groupText.anchor.set(0.5, 0.5)

            groupText.text = group.properties.point_count

            groupIcon.interactive = true
            groupIcon.buttonMode = true

            groupIcon.on('pointerdown', () => {
              let vzoom = zoom + 1

              if (vzoom > state.activeBasemap.max_zoom) {
                vzoom = state.activeBasemap.max_zoom
              }

              const vview = [
                group.properties.lat,
                group.properties.lon
              ]

              state.mapLayer.setView(vview, vzoom)
              commit('setMapControl', {
                zoom: vzoom,
                view: vview
              })
            })

            kapalContainer.addChild(groupIcon)
            kapalContainer.addChild(groupText)
          } else {
            const kapalIcon = new PIXI.Sprite(
              group.properties.jenis_kapal == 'Kapal Penangkap' ?
              (group.properties.skema_permohonan === 'PRA PRODUKSI' ? kapalIcon1 : kapalIcon2)
              :
              (group.properties.skema_permohonan === 'PRA PRODUKSI' ? kapalIcon4 : kapalIcon5)
            )

            kapalIcon.zIndex = 1
            kapalIcon.x = position.x
            kapalIcon.y = position.y
            kapalIcon.angle = group.properties.heading

            kapalIcon.anchor.set(0.5, 0.5)
            kapalIcon.scale.set(0.25 / scale)

            const kapalIconWidth = (kapalIcon.width / 4)
            const kapalIconHeight = (kapalIcon.height / 4)

            kapalIcon.interactive = true
            kapalIcon.interactiveChildren = true
            kapalIcon.buttonMode = true

            kapalIcon.on('pointerdown', () => {
              toggleInicon()

              if (rootState.tools.tools.map.distance) {
                if (toolDistances.list[group.properties.transmitter]) {
                  removeToolDistance(group.properties.transmitter)
                } else {
                  addToolDistance(group.properties.transmitter, [group.geometry.coordinates[1], group.geometry.coordinates[0]])
                }
              } else {
                if (cursors.list[group.properties.transmitter]) {
                  commit('setKapal', { transmitter: null })
                } else {
                  commit('setKapal', group.properties)
                }

                toggleCursor(group.properties.transmitter, group.geometry.coordinates)
              }

              pixiOverlay.redraw()
            })

            kapalContainer.addChild(kapalIcon)

            if (cursors.list[group.properties.transmitter]) {
              editCursor(group.properties.transmitter, {
                timestamp: cursors.timestamp,
                width: kapalIconWidth,
                height: kapalIconHeight,
                position: position,
                ping_time: group.properties.ping_time,
                speed: group.properties.speed
              })
            }

            if (toolDistances.list[group.properties.transmitter]) {
              editToolDistance(group.properties.transmitter, {
                timestamp: toolDistances.timestamp,
                width: kapalIconWidth,
                height: kapalIconHeight,
                position: position
              })
            }
          }
        }
      }

      for (let cursorIndex in cursors.list) {
        const cursor = cursors.list[cursorIndex]

        if (cursor.timestamp !== cursors.timestamp) {
          continue
        }

        const cursorTooltipContainer = new PIXI.Graphics()
        const cursorTooltextContainer = new PIXI.BitmapText('', {
          fontName: 'KapalTooltip'
        })
        const cursorSelectedContainer = new PIXI.Graphics()

        cursorTooltipContainer.zIndex = 2
        cursorTooltextContainer.zIndex = 2
        cursorTooltextContainer.zIndex = 2

        cursorTooltipContainer.beginFill(0xffffff, 0)
        cursorTooltipContainer.drawRoundedRect(0, 0, 192, 35, 10)
        cursorTooltipContainer.endFill()
        cursorSelectedContainer.beginFill(0x0000ff)
        cursorSelectedContainer.drawCircle(0, 0, 7.5)
        cursorSelectedContainer.endFill()

        cursorTooltipContainer.x = cursor.width + cursor.position.x
        cursorTooltipContainer.y = cursor.height + cursor.position.y

        cursorTooltipContainer.scale.set(1 / scale)

        cursorSelectedContainer.x = cursor.position.x
        cursorSelectedContainer.y = cursor.position.y

        cursorSelectedContainer.scale.set(1 / scale)

        cursorTooltextContainer.x = cursor.position.x + cursor.width + (cursorTooltipContainer.width / 2)
        cursorTooltextContainer.y = cursor.position.y + cursor.height + (cursorTooltipContainer.height / 2)

        cursorTooltextContainer.text = `Tanggal: ${libs.localTime(cursor.ping_time, 'full', false, false, false)}\nKecepatan: ${cursor.speed / 10} knot`

        cursorTooltextContainer.anchor.set(0.5, 2)
        cursorTooltextContainer.scale.set(1 / scale)

        kapalContainer.addChild(cursorTooltipContainer)
        kapalContainer.addChild(cursorTooltextContainer)
        kapalContainer.addChild(cursorSelectedContainer)
      }

      for (let unlistIndex in toolDistances.unlist) {
        const distanceIndex = unlistIndex
        const unlist = toolDistances.list[distanceIndex]
        const unlistIcon = new PIXI.Sprite(locationIcon)
        const position = utils.latLngToLayerPoint(unlist.coordinates)

        unlistIcon.x = position.x
        unlistIcon.y = position.y

        unlistIcon.anchor.set(0.5, 0.5)
        unlistIcon.scale.set(0.25 / scale)

        const unlistIconWidth = (unlistIcon.width / 4)
        const unlistIconHeight = (unlistIcon.height / 4)

        unlistIcon.interactive = true
        unlistIcon.interactiveChildren = true
        unlistIcon.buttonMode = true

        unlistIcon.on('pointerdown', () => {
          toggleInicon()

          if (rootState.tools.tools.map.distance) {
            removeToolDistance(distanceIndex)
          }

          pixiOverlay.redraw()
        })

        kapalContainer.addChild(unlistIcon)

        editToolDistance(distanceIndex, {
          timestamp: toolDistances.timestamp,
          width: unlistIconWidth,
          height: unlistIconHeight,
          position: position
        })
      }

      for (let distanceIndex in toolDistances.list) {
        const distanceY = toolDistances.list[distanceIndex]

        if (distanceY.timestamp !== toolDistances.timestamp) {
          continue
        }

        if (distanceY.type === 'y') {
          const distanceX = toolDistances.list[distanceY.x]

          if (distanceX.timestamp !== toolDistances.timestamp) {
            continue
          }

          const distance = Math.round(mapLayer.distance(distanceX.coordinates, distanceY.coordinates) / 1609.34)
          const distanceLineContainer = new PIXI.Graphics()

          distanceLineContainer.zIndex = 10

          toolsContainer.addChild(distanceLineContainer)

          distanceLineContainer
            .lineStyle(1 / scale, 0xEBFF00, 1, 0.5, true)
            .moveTo(
              distanceX.position.x,
              distanceX.position.y
            )
            .lineTo(distanceY.position.x, distanceY.position.y)

          const distanceTooltextContainer = new PIXI.BitmapText(
            `${distance} mi`,
            { fontName: 'KapalTooltip' }
          )

          distanceTooltextContainer.scale.set(1 / scale)

          const distanceTooltipContainer = new PIXI.Graphics()
          const distanceTooltipWidth = distanceTooltextContainer.textWidth / 5
          const distanceTooltipHeight = distanceTooltextContainer.textHeight / 2

          distanceTooltipContainer.beginFill(0xffffff, 0.5)
          distanceTooltipContainer.drawRoundedRect(
            0,
            0,
            (distanceTooltextContainer.textWidth + distanceTooltipWidth),
            (distanceTooltextContainer.textHeight + distanceTooltipHeight),
            10
          )
          distanceTooltipContainer.endFill()
          distanceTooltipContainer.scale.set(1 / scale)

          distanceTooltipContainer.x = distanceX.width + distanceY.position.x
          distanceTooltipContainer.y = distanceX.height + distanceY.position.y
          distanceTooltextContainer.x = distanceX.width + distanceY.position.x + (distanceTooltipContainer.width / 2)
          distanceTooltextContainer.y = distanceX.height + distanceY.position.y + (distanceTooltipContainer.height / 2)

          distanceTooltextContainer.anchor.set(0.5, 0.5)

          toolsContainer.addChild(distanceTooltipContainer)
          toolsContainer.addChild(distanceTooltextContainer)
        }
      }

      if (rootState.poi.poi.wpp.enable === 'AKTIF' &&
        rootState.geo.geoWPP) {
        for (var wppIndex in rootState.geo.geoWPP.features) {
          const wpp = rootState.geo.geoWPP.features[wppIndex]

          if (typeof rootState.poi.poi.wpp.aktif[wpp.properties.wpp_id] === 'undefined') {
            continue
          }

          let wppLineContainer = new PIXI.Graphics()

          wppLineContainer.interactive = true
          wppLineContainer.buttonMode = true

          let entry = {
            index: 0,
            current: wpp.geometry.coordinates[0],
            base: wpp.geometry.coordinates,
            root: null
          }
          let first = true

          wppLineContainer.beginFill(0x6495ED, 0.3)

          while (typeof entry.current !== 'undefined') {
            if (entry.current instanceof Array) {
              entry = {
                index: 0,
                current: entry.current[0],
                base: entry.current,
                root: entry
              }
            } else {
              const position = utils.latLngToLayerPoint([entry.base[1], entry.base[0]])

              if (first) {
                wppLineContainer.moveTo(position.x, position.y)

                first = false
              }

              wppLineContainer.lineTo(position.x, position.y)

              while(entry.root !== null) {
                entry = entry.root
                entry.index += 1
                entry.current = entry.base[entry.index]

                if (typeof entry.current !== 'undefined') {
                  break
                } else if (entry.root !== null &&
                  typeof entry.root.base[entry.root.index + 1] !== 'undefined') {
                  first = true
                }
              }
            }
          }

          wppLineContainer.endFill()

          wppLineContainer.on('mouseover', () => {
            wppLineContainer.tint = 0x649500

            renderer.render(container)
          })

          wppLineContainer.on('mouseout', () => {
            wppLineContainer.tint = 0x6495ED

            renderer.render(container)
          })

          wppLineContainer.on('pointerdown', () => {
            commit('setCustomFilter', {
              index: 'current_wpp',
              value: wpp.properties
            })

            dispatch('toActiveMenu', {
              name: 'Optional',
              force: true
            })

            commit('setActiveSubMenu', 'ListKapalCurrentWPP')
          })

          wppContainer.addChild(wppLineContainer)
        }
      }

      if (rootState.poi.poi.port.enable === 'AKTIF' &&
        rootState.geo.geoPortzone) {
        for (var portIndex in rootState.geo.geoPortzone.features) {
          const port = rootState.geo.geoPortzone.features[portIndex]

          if (rootState.geo.settingPortsActive[portIndex] === 'undefined') {
            continue
          }

          const portBuffer = new PIXI.Graphics()

          portBuffer.interactive = true
          portBuffer.buttonMode = true

          const points = []

          for (var pos of port.geometry.coordinates[0][0]) {
            pos = utils.latLngToLayerPoint([pos[1], pos[0]])

            points.push(pos.x)
            points.push(pos.y)
          }

          portBuffer.lineStyle(0.5, 0x6495ED, 1)
          portBuffer.beginFill(0x6495ED, 0.1)
          portBuffer.drawPolygon(points)
          portBuffer.endFill()

          portBuffer.on('mouseover', () => {
            portBuffer.tint = 0x649500

            renderer.render(container)
          })

          portBuffer.on('mouseout', () => {
            portBuffer.tint = 0x6495ED

            renderer.render(container)
          })

          portBuffer.on('pointerdown', () => {
            if (!port.tooltip) {
              const bounds = portBuffer.getLocalBounds()

              const portTooltip = new PIXI.BitmapText(
                port.properties.nama_pelab,
                {
                  fontName: 'PortTooltip'
                }
              )

              portTooltip.anchor.set(0.5, 0.5)
              portTooltip.scale.set(1 / scale)

              portTooltip.position.set(
                bounds.x + bounds.width / 2,
                bounds.y + bounds.height / 2
              )

              portBuffer.addChild(portTooltip)

              port.tooltip = portTooltip
            } else {
              portBuffer.removeChild(port.tooltip)
              port.tooltip.destroy()
              port.tooltip = null
            }

            renderer.render(container)
          })

          portContainer.addChild(portBuffer)
        }
      }

      container.addChild(kapalContainer)
      container.addChild(toolsContainer)
      container.addChild(wppContainer)
      container.addChild(portContainer)
      renderer.render(container)

      if (redraw) {
        redraw = false
        inload = false

        pixiOverlay.redraw()
      } else {
        inload = false
      }
    },
    pixiContainer,
    {
      pane: 'markerPane'
    }).addTo(mapLayer)

    mapLayer.on('click', (e) => {
      if (inicon) {
        toggleInicon()

        return
      }

      if (state.mapControl.mode === 'plotting' &&
        rootState.plotting.plotting.pointer === true) {
        const direction = libs.angle(
          [e.latlng.lat, e.latlng.lng],
          [rootState.plotting.plotting.indexed.latitude, rootState.plotting.plotting.indexed.longitude]
        )

        commit('setPlottingHeading', direction)
        dispatch('toCopyPlot', {
          latitude: e.latlng.lat,
          longitude: e.latlng.lng,
          heading: direction
        })
        dispatch('toZoom', {
          view: [
            rootState.plotting.plotting.indexed.latitude,
            rootState.plotting.plotting.indexed.longitude
          ]
        })
      } else if (rootState.tools.tools.map.distance) {
        addToolDistance(Date.now(), [e.latlng.lat, e.latlng.lng], true)
        pixiOverlay.redraw()
      } else if (rootState.menus.activeMenu) {
        if (rootState.menus.activeMenu !== 'Optional') {
          dispatch('toActiveMenu', {
            name: rootState.menus.activeMenu
          })
        }
      }
    })

    commit('setMapLayer', mapLayer)
    commit('setGroupLayer', groupLayer)
    commit('setTileLayer', tileLayer)
    commit('setGridLayer', gridLayer)
    commit('setPixiOverlay', pixiOverlay)

    await dispatch('toLoadActiveLayers')
  },
  toRedraw: ({ state }) => {
    state.pixiOverlay.redraw()
  },
  toLoadActiveFilter: async ({ rootState, commit }) => {
    commit('setLoading', 'load active filter')

    let activeFilter = window.localStorage.getItem('poi_filter')
    let selectedFilter = rootState.kapal.filter[activeFilter]

    if (selectedFilter) {
      commit('setActiveFilter', activeFilter)
    }

    commit('unsetLoading')
  },
  toChangeActiveFilter: async ({ rootState, commit, dispatch }, filterIndex) => {
    commit('setLoading', 'mengganti filter')

    let selectedFilter = rootState.kapal.filter[filterIndex]

    if (selectedFilter) {
      await dispatch('authenticatedApi', {
        method: 'put',
        url: `${window.config.BASEURL_API1}/user-config`,
        data: {
          'filter': selectedFilter.id
        }
      })

      window.localStorage.setItem('poi_filter', selectedFilter.id)

      commit('setActiveFilter', filterIndex)

      await dispatch('toLoadListKapal')

      dispatch('toRedraw')
    }

    commit('unsetLoading')
  },
  toLoadActiveBasemap: async ({ commit, dispatch }) => {
    commit('setLoading', 'load active basemap')

    let activeBasemap = window.localStorage.getItem('active_basemap')
    let selectedBasemap = null

    try {
      selectedBasemap = JSON.parse(activeBasemap)
    } catch (err) {
      selectedBasemap = null
    }

    if (!selectedBasemap) {
      const activeBasemapId = parseInt(window.localStorage.getItem('poi_layer')) || null

      let basemaps = await dispatch('authenticatedApi', {
        method: 'get',
        url: `${window.config.BASEURL_API1}/basemap`
      })

      if (basemaps) {
        for (var basemap of basemaps.data.basemap) {
          if (basemap.id === activeBasemapId) {
            selectedBasemap = basemap
            break
          } else if (activeBasemapId === null && basemap.default === 'YES') {
            selectedBasemap = basemap
            break
          }
        }
      } else {
        selectedBasemap = null
      }
    }

    if (selectedBasemap) {
      commit('setActiveBasemap', selectedBasemap)
    }

    commit('unsetLoading')
  },
  toLoadActiveLayers: async ({ commit, dispatch }) => {
    commit('setLoading', 'memuat active layer')

    const layers = await dispatch('authenticatedApi', {
      method: 'get',
      url: `${window.config.BASEURL_API1}/layers`
    })

    if (layers) {
      try {
        const layerShow = JSON.parse(window.localStorage.getItem('poi_layers_show'))

        for (var layer of layers.data.layers) {
          const layerIdString = `${layer.id}`

          for (var layerId in layerShow) {
            if (layerId === layerIdString) {
              layer.enable = layerShow[layerId]

              dispatch('toggleLayer', layer)
            }
          }
        }

        commit('setLayers', layers.data.layers)
      } catch (err) {
        // something error with layer config
      }
    }

    commit('unsetLoading')
  },
  toChangeLayerOSM: ({ state, commit }) => {
    commit('setLoading', 'mengganti layer')

    const selectedLayer = {
      id: 5,
      title: 'OSM',
      url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '<a href="https://www.openstreetmap.org/copyright">©  OpenStreetMap contributors</a>',
      max_zoom: 20
    }

    const tileLayer = L.tileLayer(selectedLayer.url, {
      id: 1,
      attribution: selectedLayer.attribution,
      maxZoom: selectedLayer.max_zoom,
      tileSize: 256,
      // zoomOffset: -1
    })

    state.mapLayer.addLayer(tileLayer)

    commit('setActiveBasemap', selectedLayer)
    commit('setTileLayer', tileLayer)
    commit('unsetLoading')
  },
  toChangeActiveBasemap: async ({ rootState, state, commit, dispatch }, basemapIndex) => {
    commit('setLoading', 'mengganti layer')

    const selectedLayer = rootState.poi.basemap[basemapIndex]

    if (selectedLayer) {
      await dispatch('authenticatedApi', {
        method: 'put',
        url: `${window.config.BASEURL_API1}/user-config`,
        data: {
          'layer': selectedLayer.id
        }
      })

      const tileLayer = L.tileLayer(selectedLayer.url, {
        id: selectedLayer.id,
        attribution: selectedLayer.attribution,
        maxZoom: selectedLayer.max_zoom,
        tileSize: 256,
        // zoomOffset: -1
      })

      state.mapLayer.addLayer(tileLayer)

      window.localStorage.setItem('poi_layer', selectedLayer.id)

      commit('setActiveBasemap', selectedLayer)
      commit('setTileLayer', tileLayer)
    }

    commit('unsetLoading')
  },
  toDrawWPP: async ({ state }) => {
    state.pixiOverlay.redraw()
  },
  toReloadWPP: async ({ state }) => {
    state.pixiOverlay.redraw()
  },
  toRemoveWPP: ({ state, commit }) => {
    if (!state.wppLayer) return

    state.wppLayer.removeFrom(state.groupLayer)
    commit('setWPPLayer', null)
  },
  toDrawPorts: async ({ rootState, state, commit, dispatch }) => {
    state.pixiOverlay.redraw()
  },
  toRemovePorts: ({ state, commit }) => {
    state.pixiOverlay.redraw()
  },
  toDrawListKapal: async ({ rootState, state, commit, dispatch }, { offset = false, limit = false, load = true }) => {
    if (state.mapControl.mode === 'history' ||
      state.mapControl.mode === 'plotting') {
      return
    }

    if (offset === false && limit === false) {
      offset = state.mapControl.lastOffset
      limit = state.mapControl.lastLimit
    }

    if (load || state.mapControl.completeload === false) {
      commit('setLoading', 'load list kapal')
      await dispatch('toLoadListKapal', { offset, limit })

      state.pixiOverlay.redraw()

      offset = offset + limit

      if (offset < rootState.kapal.listKapal.total) {
        commit('setMapControl', {
          lastOffset: offset,
          lastLimit: limit
        })

        await dispatch('toDrawListKapal', { offset, limit })
      } else {
        commit('setMapControl', {
          completeload: true,
          lastOffset: offset,
          lastLimit: limit
        })
        commit('unsetLoading')
      }
    } else {
      state.pixiOverlay.redraw()
    }
  },
  toDrawZones: ({ rootState, state, commit, dispatch }) => {
    // add all available zone
    for (let zoneId in rootState.poi.listZone) {
      const zone = rootState.poi.listZone[zoneId]

      if (zone.enable &&
        typeof state.zoneLayer[zoneId] !== 'undefined') {
        state.groupLayer.addLayer(state.zoneLayer[zoneId])
      } else if (zone.enable && zone.geo !== null) {
        const zoneLayer = L.geoJSON(zone.geo)

        state.groupLayer.addLayer(zoneLayer)

        commit('setZoneLayer', {
          id: zone.id,
          layer: zoneLayer
        })
      } else if (!zone.enable &&
        typeof state.zoneLayer[zoneId] !== 'undefined') {
          state.zoneLayer[zoneId].removeFrom(state.groupLayer)
      }
    }

    dispatch('toRedraw')
  },
  toRemoveZones: ({ rootState, state, dispatch }) => {
    // add all available zone
    for (let zoneId in rootState.poi.listZone) {
      if (typeof state.zoneLayer[zoneId] !== 'undefined') {
        state.zoneLayer[zoneId].removeFrom(state.groupLayer)
      }
    }

    dispatch('toRedraw')
  },
  toggleLayer: ({ state, commit }, layer) => {
    if (state.activeLayers[layer.id]) {
      state.groupLayer.removeLayer(state.activeLayers[layer.id])

      commit('setActiveLayer', {
        id: layer.id,
        layer: null
      })
    } else {
      if (layer.type === 'image') {
        const layerImage = L.tileLayer.wms(layer.url, {
          layers: layer.config.name,
          transparent: true,
          format: 'image/png'
        }).addTo(state.groupLayer)

        commit('setActiveLayer', {
          id: layer.id,
          layer: layerImage
        })
      }
    }
  },
  toZoom: ({ state, commit }, { view = null, zoom = null} = {}) => {
    if (zoom === null) {
      zoom = state.mapLayer.getZoom()
    }

    if (view === null) {
      view = state.mapLayer.getCenter()
    }

    commit('setMapControl', { view, zoom })

    state.mapLayer.setView(view, zoom)
  },
  toZoomIn: ({ state, commit }, isScroll = false) => {
    const newZoomState = state.mapControl.zoom + 1

    if (newZoomState <= state.activeBasemap.max_zoom) {
      if (!isScroll) {
        state.mapLayer.setView(state.mapLayer.getCenter(), newZoomState)
      }

      commit('setMapControl', { zoom: newZoomState })
    }
  },
  toZoomOut: ({ state, commit }, isScroll = false) => {
    const newZoomState = state.mapControl.zoom - 1

    if (newZoomState >= 1) {
      if (!isScroll) {
        state.mapLayer.setView(state.mapLayer.getCenter(), newZoomState)
      }

      commit('setMapControl', { zoom: newZoomState })
    }
  },
  toZoomReset: ({ state, commit }) => {
    state.mapLayer.setView(state.mapControl.view, 5)
    commit('setMapControl', { zoom: 5 })
  },
  toChangeCursor: ({ state }, cursor = 'grab') => {
    state.mapLayer.getContainer().style.cursor = cursor
  },
  toInitCapture: ({ state, commit }) => {
    if (state.captureLayer === null) {
      const mapSize = state.mapLayer.getSize()
      const captureLayer = new PIXI.Application({
        width: mapSize.x,
        height: mapSize.y
      })

      document.body.appendChild(captureLayer.view)
      commit('setCaptureLayer', captureLayer)
    }
  },
  toCapture: ({ state, commit }, captureType) => {
    if (state.capture.inload) return

    state.capture.inload = true

    const tilePane = state.mapLayer.getPane('tilePane')
    const tileLayer = tilePane.children[0].children[tilePane.children[0].children.length - 1]
    const pane = tilePane.parentNode

    const panePos = window.getComputedStyle(pane)
                      .getPropertyValue('transform')
                      .split(',')
    const paneX = parseInt(panePos[4])
    const paneY = parseInt(panePos[5])
    const tileLayerPos = window.getComputedStyle(tileLayer)
                          .getPropertyValue('transform')
                          .split(',')
    const tileLayerX = parseInt(tileLayerPos[4])
    const tileLayerY = parseInt(tileLayerPos[5])

    const mainContainer = new PIXI.Container()
    const loader = new PIXI.Loader()
    const layers = {}

    for (let tileIndex = 0; tileIndex < tileLayer.children.length; tileIndex++) {
      const tileId = `tile-${tileIndex}`
      const tileImg = tileLayer.children[tileIndex]

      loader.add(tileId, tileImg.src)

      const tilePos = window.getComputedStyle(tileImg)
                        .getPropertyValue('transform')
                        .split(',')

      layers[tileId] = {
        x: paneX + tileLayerX + parseInt(tilePos[4]),
        y: paneY + tileLayerY + parseInt(tilePos[5]),
        width: 256,
        height: 256,
        zIndex: 1
      }
    }

    const getMarkers = state.pixiOverlay._renderer.generateTexture(
      state.pixiOverlay._pixiContainer,
      { region: state.pixiOverlay._renderer.screen }
    )
    const markers = state.pixiOverlay._renderer.plugins.extract.image(getMarkers, 'image/png', 1)

    getMarkers.destroy()
    loader.add('markers', markers.src)

    layers['markers'] = {
      x: -(state.pixiOverlay._renderer.screen.width - state.captureLayer.screen.width) / 2,
      y: -(state.pixiOverlay._renderer.screen.height - state.captureLayer.screen.height) / 2,
      width: state.pixiOverlay._renderer.screen.width,
      height: state.pixiOverlay._renderer.screen.height,
      zIndex: 2
    }

    state.captureLayer.stage.sortableChildren = true

    loader.load((renderer, resources) => {
      for (let layerId in layers) {
        const layer = layers[layerId]
        const layerSprite = new PIXI.Sprite(resources[layerId].texture)

        layerSprite.x = layer.x
        layerSprite.y = layer.y
        layerSprite.width = layer.width
        layerSprite.height = layer.height
        layerSprite.zIndex = layer.zIndex
        layers[layerId].sprite = layerSprite

        mainContainer.addChild(layerSprite)
      }

      state.captureLayer.stage.addChild(mainContainer)

      const captured = state.captureLayer.renderer.generateTexture(
        state.captureLayer.stage,
        { region: state.captureLayer.screen }
      )

      const resultCapture = state.captureLayer.renderer.plugins.extract.image(captured, 'image/png', 1)

      captured.destroy()
      mainContainer.destroy(true)
      loader.destroy()

      if (captureType === 'inset') {
        commit('setCaptureB', resultCapture.src)
      } else {
        commit('setCaptureA', resultCapture.src)
      }
    })

    state.capture.inload = false
  }
}

const mutations = {
  setMapLayer: (state, mapLayer) => state.mapLayer = mapLayer,
  setGroupLayer: (state, groupLayer) => state.groupLayer = groupLayer,
  setTileLayer: (state, tileLayer) => state.tileLayer = tileLayer,
  setGridLayer: (state, gridLayer) => state.gridLayer = gridLayer,
  setPixiOverlay: (state, pixiOverlay) => state.pixiOverlay = pixiOverlay,
  setWPPLayer: (state, wppLayer) => state.wppLayer = wppLayer,
  setMapControl: (state, mapControl) => state.mapControl = { ...state.mapControl, ...mapControl },
  setMapPlay: (state, mapPlay) => state.mapPlay = { ...state.mapPlay, ...mapPlay },
  setActiveBasemap: (state, activeBasemap) => {
    window.localStorage.setItem('active_basemap', JSON.stringify(activeBasemap))

    state.activeBasemap = { ...activeBasemap, ...activeBasemap }
  },
  setActiveLayer: (state, activeLayer) => {
    state.activeLayers[activeLayer.id] = activeLayer.layer
  },
  setCaptureLayer: (state, captureLayer) => state.captureLayer = captureLayer,
  setCaptureA: (state, captureMain) => state.capture.a = captureMain,
  setCaptureB: (state, captureInset) => state.capture.b = captureInset,
  setZoneLayer: (state, zone) => state.zoneLayer[zone.id] = zone.layer
}

export default {
  state,
  getters,
  actions,
  mutations
}
